import { useEffect } from "react"
import { useGetPlayerSettingsQuery } from "@/store/apis/playerAPI"

const audioContext = new (window.AudioContext ||
  (window as any).webkitAudioContext)()

const audioBuffers = new Map<string, AudioBuffer>()

const gainNode = audioContext.createGain()
gainNode.connect(audioContext.destination)

const basePath = "/assets/sounds"

const soundMap = {
  "deck-reshuffled": `${basePath}/deck-reshuffled.mp3`,
  "card-discarded": `${basePath}/card-discarded.mp3`,
  "deck-to-player": `${basePath}/deck-to-player.mp3`
} as const

export type SoundName = keyof typeof soundMap

export const useAudioController = () => {
  const { data: settings, isFetching } = useGetPlayerSettingsQuery()

  const resumeAudioContext = () => {
    if (audioContext.state === "suspended") {
      audioContext.resume()
    }
  }

  useEffect(() => {
    window.addEventListener("click", resumeAudioContext, { once: true })

    return () => {
      window.removeEventListener("click", resumeAudioContext)
    }
  }, [])

  // Оновлюємо гучність при зміні settings
  if (settings?.musicVolume !== undefined) {
    const volume = settings.isSoundMute ? 0 : settings.musicVolume / 100
    gainNode.gain.value = volume
  }

  const playSound = async (name: SoundName) => {
    if (!isFetching && !!settings?.isSoundMute) return

    try {
      if (!soundMap[name]) {
        console.warn(`Sound not found "${name}"`)
        return
      }

      if (!audioBuffers.has(name)) {
        try {
          const response = await fetch(soundMap[name])
          const arrayBuffer = await response.arrayBuffer()
          const buffer = await audioContext.decodeAudioData(arrayBuffer)
          audioBuffers.set(name, buffer)
        } catch (error) {
          console.error(`Error while load sound "${name}":`, error)
          return
        }
      }

      const buffer = audioBuffers.get(name)
      if (!buffer) return

      const source = audioContext.createBufferSource()
      source.buffer = buffer
      source.connect(gainNode)
      source.start(0)
    } catch {
      //catch
    }
  }

  return { playSound }
}
